// src/socket/signalingClient.js
import { io } from "socket.io-client";

let socket = null;

const SOCKET_URL =
  process.env.NODE_ENV === "production"
    ? "https://nukkad.vemeet.online"  // use your domain with HTTPS
    : "http://localhost:5000";        // keep localhost for testing

export const connectSocket = (userId) => {
  if (socket) return socket;

  socket = io(SOCKET_URL, {
    transports: ["websocket"],
    query: { userId },
  });

  socket.on("connect", () => {
    console.log("✅ Socket connected:", socket.id, "user:", userId);
  });

  socket.on("disconnect", () => {
    console.log("❌ Socket disconnected");
  });

  return socket;
};

export const joinRoom = (roomId, userId) => {
  if (!socket || !roomId) return;
  socket.emit("join-room", { roomId, userId });
  console.log("🚪 Joined room:", roomId, "user:", userId);
};

export const sendOffer = (roomId, offer) => {
  if (!socket) return;
  socket.emit("offer", { roomId, offer });
};

export const sendAnswer = (roomId, answer) => {
  if (!socket) return;
  socket.emit("answer", { roomId, answer });
};

export const sendCandidate = (roomId, candidate) => {
  if (!socket) return;
  socket.emit("candidate", { roomId, candidate });
};

export const onOffer = (cb) => {
  if (!socket) return;
  socket.off("offer").on("offer", ({ offer }) => cb(offer));
};

export const onAnswer = (cb) => {
  if (!socket) return;
  socket.off("answer").on("answer", ({ answer }) => cb(answer));
};

export const onCandidate = (cb) => {
  if (!socket) return;
  socket.off("candidate").on("candidate", ({ candidate }) => cb(candidate));
};
